import { Project } from '../Interface/ProjectInterface';
const projects: Project[] = [
    {
        sNo: 1,
        image: 'https://raw.githubusercontent.com/Sachin-Prasad-29/sachin-prasad/work-branch/src/assets/project/calendar.png',
        title: 'Calender and Events',
        desc: 'A Calendar app using to create events,tasks & reminder with friends',
        techStack: [
            'HTMl',
            'CSS',
            'Javascript',
            'VueJs',
            'Vuetify',
            'Express',
            'MongoDB',
        ],
        repoUrl: '"https://github.com/Sachin-Prasad-29/calendar-and-events-app',
        liveUrl: 'https://calendar-and-events.netlify.app',
    },
    {
        sNo: 2,
        image: 'https://raw.githubusercontent.com/Sachin-Prasad-29/sachin-prasad/work-branch/src/assets/project/meeting.png',
        title: 'Meeting Application',
        desc: 'A Meeting Application used to create meeting with other members and teams.',
        techStack: ['HTMl', 'CSS', 'JavaScript', 'Vue Js'],
        repoUrl: 'https://github.com/Sachin-Prasad-29/Meetings-Applications',
        liveUrl: 'https://meeting-application-29.netlify.app',
    },
    {
        sNo: 3,
        image: 'https://raw.githubusercontent.com/Sachin-Prasad-29/sachin-prasad/work-branch/src/assets/project/gamestore.png',
        title: 'Game Store',
        desc: 'A static page for the game store build for the landing page.Which showcase Different games.',
        techStack: ['HTMl', 'CSS', 'BootStrap'],
        repoUrl: 'https://github.com/Sachin-Prasad-29/Game-Store',
        liveUrl: 'https://game-store-29.netlify.app',
    },
    {
        sNo: 4,
        image: 'https://raw.githubusercontent.com/Sachin-Prasad-29/sachin-prasad/work-branch/src/assets/project/grocery.png',
        title: 'Grocery Bud',
        desc: 'A simple React Grocery bud application created using react hooks, can be used to write grocery list.',
        techStack: ['HTMl', 'CSS', 'React Js'],
        repoUrl: 'https://github.com/Sachin-Prasad-29/10-Grocery-Bud',
        liveUrl: 'https://grocery-bud-react-js.netlify.app',
    },
    {
        sNo: 5,
        image: 'https://raw.githubusercontent.com/Sachin-Prasad-29/sachin-prasad/work-branch/src/assets/project/colorpicker.png',
        title: 'Color Picker',
        desc: 'A simple Application used to find the different shades of searched color using Value js library.',
        techStack: ['HTMl', 'CSS', 'React js', 'Value js library'],
        repoUrl:
            'https://github.com/Sachin-Prasad-29/09-Color-Shades-Generator',
        liveUrl: 'https://colorpicker-react.netlify.app',
    },
    {
        sNo: 6,
        image: 'https://raw.githubusercontent.com/Sachin-Prasad-29/sachin-prasad/work-branch/src/assets/project/project-man.png',
        title: 'Project Manager',
        desc: 'A Frontend Project built using Vuetify Ui library which can be used to show the team list and project lists.',
        techStack: ['HTMl', 'CSS', 'Vue Js', 'Vuetify'],
        repoUrl: 'https://github.com/Sachin-Prasad-29/project-manager',
        liveUrl: 'https://project-manager-vue.netlify.app',
    },
    {
        sNo: 7,
        image: 'https://raw.githubusercontent.com/Sachin-Prasad-29/sachin-prasad/work-branch/src/assets/project/resturant.png',
        title: 'Restaurant Page',
        desc: 'A Frontend Restaurant Project built which shows different menus and items of the Restaurant.',
        techStack: ['HTMl', 'CSS', 'JavaScript'],
        repoUrl: 'https://github.com/Sachin-Prasad-29/Resturant-Website-2',
        liveUrl: 'https://basic-resturant-js.netlify.app',
    },
    {
        sNo: 8,
        image: 'https://raw.githubusercontent.com/Sachin-Prasad-29/sachin-prasad/work-branch/src/assets/project/todo-vue.png',
        title: 'Todo List 1',
        desc: 'A Simple todo List build using Vue js. User can create, mark as completed and Delete the todo.',
        techStack: ['HTMl', 'CSS', 'Vue Js'],
        repoUrl: 'https://github.com/Sachin-Prasad-29/Todos-vue-js-app',
        liveUrl: 'https://todo-list-vue-1.netlify.app',
    },
    {
        sNo: 9,
        image: 'https://raw.githubusercontent.com/Sachin-Prasad-29/sachin-prasad/work-branch/src/assets/project/todo-vuex.png',
        title: 'Todo List 2',
        desc: 'A Simple todo List build using Vue js and Vuex which is using to showcase the working of state Management.',
        techStack: ['HTMl', 'CSS', 'Vue Js', 'Vue X'],
        repoUrl: 'https://github.com/Sachin-Prasad-29/todos-vuex-app',
        liveUrl: 'https://todo-list-vuex-2.netlify.app',
    },
];

export default projects;
